/*
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: v-auth 权限码指令
 */
import Utils from '@/utils/utils';
import { AUTH_CODE_LIST } from '@/views/layout/constant';

function check(authCode) {
  return Utils.Local.getObject(AUTH_CODE_LIST).includes(authCode)
}

export default {
  inserted(el, binding) {
    if (!check(binding.value)) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
}